export function areTreesEqual(tree1, tree2) {
    return tree1.every((tag, index) => tag.getId() === tree2[index].getId());
}